<template >
  <div class="default-spacing default-styling" :class="classes">
    <slot></slot>
  </div>
</template>

<script>
export default {
  mounted() {
    const element = this.$el;
    const attributeNames = element.getAttributeNames();

    if (!attributeNames.includes('flat')) this.classes += ' elevated';
    if (attributeNames.includes('outlined')) this.classes += ' outlined';
  },
  data() {
    return {
      classes: ''
    };
  }
};
</script>

<style lang="scss" scoped>
.default-styling {
  background-color: var(--v-b_card-base);
}
.default-spacing {
  margin: 10px;
  padding: 15px;
}
.elevated {
  border-radius: 4px;
}
.outlined {
  border: 2px solid var(--v-border1-base);
  border-radius: 4px;
}
</style>